import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "@/assets/styles/variables.css";
import "@/assets/styles/global.css";
import "@/assets/styles/components.css";
import "@/assets/styles/buttons.css";
import "@/assets/styles/forms.css";
import '@/assets/styles/shadows.css';
import "@/assets/styles/cards.css";
import "@/assets/styles/typography.css";
import "@/assets/styles/paginas-secao.css";

 


import "bootstrap-icons/font/bootstrap-icons.css";

import { MotionPlugin } from "@vueuse/motion";

createApp(App).use(MotionPlugin).use(router).mount("#app");
